(function(){

  const head=document.getElementById('dkHead'),btn=document.getElementById('dkMenuBtn'),
        dlg=document.getElementById('dkMenu'),closeBtn=document.getElementById('dkMenuClose');
  if(!dlg||!btn)return;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine=matchMedia('(pointer:fine)').matches;

  /* Szenen — jede Welt bringt ihr eigenes Licht hinter die Seide */
  const sceneEls={};
  document.querySelectorAll('.dkc-scene,.dkc-live').forEach(el=>{
    (sceneEls[el.dataset.key]||(sceneEls[el.dataset.key]=[])).push(el);});
  function showScene(key){
    document.querySelectorAll('.dkc-scene.on,.dkc-live.on').forEach(el=>{
      el.classList.remove('on');if(el.tagName==='VIDEO')el.pause();});
    if(!key)return;
    (sceneEls[key]||[]).forEach(el=>{
      if(el.dataset.src&&!el.getAttribute('src'))el.src=el.dataset.src;
      if(el.tagName==='VIDEO'){if(reduce)return;el.classList.add('on');const p=el.play();p&&p.catch(()=>{});}
      else el.classList.add('on');});
  }
  /* Provenienz-Zeile — ein Satz Wahrheit pro Welt; Ruhezustand = die stille Frist */
  const noteEl=document.querySelector('.dkc-note');
  const noteI=noteEl?noteEl.querySelector('.ni'):null;
  let noteT=null;
  function setNote(txt,off){
    if(!noteI)return;
    const t=off?'':(txt||noteEl.dataset.default||'');
    noteEl.classList.remove('is-on');
    clearTimeout(noteT);
    if(!t){noteT=setTimeout(()=>{noteI.textContent='';},reduce?0:240);return;}
    noteT=setTimeout(()=>{noteI.textContent=t;noteEl.classList.add('is-on');},reduce?0:240);
  }
  const worlds=document.getElementById('dkWorlds');
  let startWorldRotate=null,stopWorldRotate=null;
  if(worlds&&!reduce){
    const wa=[...worlds.querySelectorAll('a')];
    if(fine){
      let hovT=null;
      const pick=a=>{clearTimeout(hovT);hovT=setTimeout(()=>{
        showScene(a?a.dataset.scene:null);
        setNote(a?a.dataset.note:null);
      },90);};
      wa.forEach(a=>{
        a.addEventListener('pointerenter',()=>pick(a));
        a.addEventListener('focus',()=>pick(a));});
      worlds.addEventListener('pointerleave',()=>pick(null));
    }else if(wa.length){
      /* Touch: kein Hover moeglich — die Welten rotieren sanft durch, solange das Menue offen ist
         (vorher lief hier gar nichts: Szene+Notiz blieben fuer jeden mobilen Besucher permanent leer) */
      let ri=0,rt=null;
      const step=()=>{showScene(wa[ri].dataset.scene);setNote(wa[ri].dataset.note);ri=(ri+1)%wa.length;rt=setTimeout(step,4200);};
      stopWorldRotate=()=>{clearTimeout(rt);rt=null;};
      startWorldRotate=()=>{stopWorldRotate();ri=0;step();};
    }
  }

  /* Vorhang — natives dialog, animierter Auf-/Abgang */
  let closing=false;
  function open(){
    const br=btn.getBoundingClientRect();
    dlg.style.setProperty('--sx',(br.left+br.width/2)+'px');
    dlg.style.setProperty('--sy',(br.top+br.height/2)+'px');
    dlg.classList.remove('is-out');
    dlg.showModal();
    document.documentElement.classList.add('dk-lock');
    window.dkLenis&&window.dkLenis.stop();
    btn.setAttribute('aria-expanded','true');
    document.querySelectorAll('.dkc-scene').forEach(el=>{
      if(el.dataset.src&&!el.getAttribute('src'))el.src=el.dataset.src;});
    startWorldRotate&&startWorldRotate();
    requestAnimationFrame(()=>requestAnimationFrame(()=>{dlg.classList.add('is-in');if(!startWorldRotate)setNote(null);}));
  }
  function shut(){
    if(closing||!dlg.open)return;closing=true;
    dlg.classList.remove('is-in');dlg.classList.add('is-out');
    setNote(null,true);
    setTimeout(()=>{dlg.close();closing=false;},reduce?0:740);
  }
  dlg.addEventListener('close',()=>{
    document.documentElement.classList.remove('dk-lock');
    window.dkLenis&&window.dkLenis.start();
    btn.setAttribute('aria-expanded','false');
    dlg.classList.remove('is-in');dlg.classList.remove('is-out');closing=false;showScene(null);
    stopWorldRotate&&stopWorldRotate();
  });
  dlg.addEventListener('cancel',e=>{e.preventDefault();shut();});
  dlg.addEventListener('click',e=>{if(e.target===dlg)shut();});

  /* Welche Welt ist gerade offen — aus der Adresse, nicht hart im Markup */
  dlg.querySelectorAll('.dkc-worlds a[href^="/"]').forEach(function(a){
    var h=(a.getAttribute('href')||'').split('#')[0].replace(/\/$/,'');
    if(h && h===location.pathname.replace(/\/$/,'')) a.setAttribute('aria-current','page');
  });

  /* Gepinnte Sektionen verschieben die Dokumenthoehe waehrend des Scrollens —
     deshalb nachmessen und korrigieren, bis die Sektion unter der Leiste sitzt. */
  function settle(t,n,smooth){
    var headH=head?head.offsetHeight:0;
    var d=t.getBoundingClientRect().top-headH;
    if(Math.abs(d)<2||n>4)return;
    var y=Math.max(0,scrollY+d), first=n===0&&smooth&&!reduce;
    if(window.dkLenis)window.dkLenis.scrollTo(y,{duration:first?1.1:.32,immediate:!first&&!smooth});
    else scrollTo({top:y,behavior:first?'smooth':'auto'});
    setTimeout(function(){settle(t,n+1,smooth);},first?1200:400);
  }
  /* Anker aus dem Register: erst faellt der Vorhang, dann faehrt die Seite zur Sektion */
  dlg.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[href*="#"]');
    if(!a)return;
    var u=new URL(a.getAttribute('href'),location.href);
    if(u.pathname.replace(/\/$/,'')!==location.pathname.replace(/\/$/,'')||!u.hash)return;
    var target=document.getElementById(u.hash.slice(1));
    if(!target)return;
    e.preventDefault(); shut();
    setTimeout(function(){
      window.ScrollTrigger&&window.ScrollTrigger.refresh();
      settle(target,0,true);
      history.replaceState(null,'',location.pathname+location.search+u.hash);
    },reduce?20:780);
  });
  /* Kommt der Anker von einer anderen Seite, springt der Browser selbst — nachziehen */
  if(location.hash.length>1){
    var zt=document.getElementById(location.hash.slice(1));
    if(zt){
      var ticks=0,stopp=false,halt=function(){stopp=true;};
      addEventListener('wheel',halt,{passive:true,once:true});
      addEventListener('touchstart',halt,{passive:true,once:true});
      var w=setInterval(function(){
        if(stopp||++ticks>14){clearInterval(w);return;}
        var hh=head?head.offsetHeight:0, d=zt.getBoundingClientRect().top-hh;
        if(Math.abs(d)>2){
          var y=Math.max(0,scrollY+d);
          if(window.dkLenis)window.dkLenis.scrollTo(y,{immediate:true}); else scrollTo({top:y,behavior:'auto'});
        }
      },280);
    }
  }
  btn.addEventListener('click',open);
  closeBtn&&closeBtn.addEventListener('click',shut);

  /* Botschafts-Deck — Ankündigung trägt Wachsrot, Wissen ruht in Schwarz */
  const deck=document.querySelector('.vy-deck');
  if(deck){
    const bar=deck.closest('.voyage');
    const ms=[...deck.querySelectorAll('.vy-msg')];
    if(bar&&ms.length>1&&!reduce){
      const DUR={reise:9500,wissen:6500};
      let i=0,t=null;
      function show(n){
        ms[i].classList.remove('is-on');i=n;ms[i].classList.add('is-on');
        bar.classList.toggle('is-reise',ms[i].dataset.kind==='reise');
      }
      function tick(){t=setTimeout(()=>{show((i+1)%ms.length);tick();},DUR[ms[i].dataset.kind]||7000);}
      tick();
      bar.addEventListener('pointerenter',()=>{clearTimeout(t);t=null;});
      bar.addEventListener('pointerleave',()=>{if(!t)tick();});
    }
  }

  /* Suchbühne im Header */
  const sBtn=document.querySelector('.dkh-search'),sForm=document.querySelector('.dkh-sform'),
        sIn=document.querySelector('.dkh-sin'),sX=document.querySelector('.dkh-sx');
  if(head&&sBtn&&sForm&&sIn){
    function sOpen(){head.classList.add('is-search');sBtn.setAttribute('aria-expanded','true');setTimeout(()=>sIn.focus(),90);}
    function sClose(){head.classList.remove('is-search');sBtn.setAttribute('aria-expanded','false');sIn.blur();sIn.value='';const l=document.querySelector('.sp-live'),d=document.querySelector('.sp-default');if(l){l.hidden=true;l.textContent='';}if(d)d.hidden=false;}
    sBtn.addEventListener('click',sOpen);
    sX&&sX.addEventListener('click',sClose);
    const sVeil=document.querySelector('.dkh-veil');sVeil&&sVeil.addEventListener('click',sClose);
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&head.classList.contains('is-search'))sClose();});
  }

  /* Live-Vorschläge — NATIVE Shopify Predictive Search (same-origin, voller Katalog) */
  const spDef=document.querySelector('.sp-default'),spLive=document.querySelector('.sp-live');
  if(sIn&&spDef&&spLive){
    const el=(t,c,txt)=>{const e=document.createElement(t);e.className=c||'';if(txt)e.textContent=txt;return e;};
    const link=(u,t)=>{const a=document.createElement('a');a.href=u;if(t)a.textContent=t;return a;};
    let liveT=null;
    function paint(prods,colls,q){
      spLive.textContent='';
      if(colls.length){spLive.append(el('p','sp-k','Direkt zu'));
        const nav=el('nav','sp-chips');colls.forEach(c=>nav.append(link(c.url,c.title)));spLive.append(nav);}
      if(prods.length){spLive.append(el('p','sp-k','Düfte'));
        const nav=el('nav','sp-sig');
        prods.forEach(p=>{const card=el('div','sp-card');const a=link(p.url,'');
          if(p.image){const img=document.createElement('img');img.src=p.image+(p.image.indexOf('?')>-1?'&':'?')+'width=268';img.alt=p.title;img.loading='lazy';a.append(img);}
          const tx=el('span','tx');const b=document.createElement('b');b.textContent=p.title;tx.append(b);
          if(p.price&&parseFloat(p.price)>0)tx.append(el('span','pr',String(p.price).replace('.00','')+' €'));
          a.append(tx);card.append(a);
          if(p.available!==false){
            const buy=el('button','sp-buy','In den Warenkorb');buy.type='button';
            buy.addEventListener('click',()=>openQuickBuy(p.url));
            card.append(buy);
          }
          nav.append(card);});
        spLive.append(nav);
        const all=link('/search?q='+encodeURIComponent(q),'Alle Treffer ansehen →');
        all.className='sp-all';spLive.append(all);}
      if(!prods.length&&!colls.length){
        const pn=el('p','sp-none','Keine Treffer — ');
        pn.append(link('/search?q='+encodeURIComponent(q),'alles durchsuchen →'));spLive.append(pn);}
      spDef.hidden=true;spLive.hidden=false;
    }
    function renderLive(){
      const q=sIn.value.trim();
      if(q.length<2){spLive.hidden=true;spDef.hidden=false;return;}
      fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection&resources[limit]=8')
        .then(r=>r.json())
        .then(d=>{if(sIn.value.trim()!==q)return;
          const rr=(d.resources&&d.resources.results)||{};
          paint(rr.products||[],rr.collections||[],q);})
        .catch(()=>{});
    }
    sIn.addEventListener('input',()=>{clearTimeout(liveT);liveT=setTimeout(renderLive,140);});
  }


  /* Beim Lesen treten die Kategorien ab — der Blick zurueck nach oben bringt sie wieder */
  (function(){
    if(!head)return;
    var lastY=window.scrollY,tick=false;
    function onS(){
      tick=false;
      var y=window.scrollY;
      /* DK-FIX 2026-07-25: lastY nur bei Schwellen-Ueberschreitung updaten -> langsames Momentum-Hochscrollen bringt die Kategorien zuverlaessig zurueck */
      if(y<60){head.classList.remove('is-slim');lastY=y;return;}
      if(y>lastY+8){head.classList.add('is-slim');lastY=y;}
      else if(y<lastY-8){head.classList.remove('is-slim');lastY=y;}
    }
    addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(onS);}},{passive:true});
  })();

  /* Kollektions-Mega-Panel: Hover zeigt die Werke der Kollektion — Bilder laden erst beim ersten Oeffnen */
  (function(){
    var panel=document.getElementById('dkhCatPanel'); if(!panel) return;
    var links=[].slice.call(document.querySelectorAll('.dkh-cats a[data-cat]'));
    var groups=[].slice.call(panel.querySelectorAll('.dkh-cpg'));
    if(!links.length||!groups.length) return;
    var openT=null,closeT=null,isOpen=false;
    function hydrate(g){g.querySelectorAll('img[data-src]').forEach(function(im){im.src=im.getAttribute('data-src');im.removeAttribute('data-src');});}
    function show(ci){
      clearTimeout(closeT);
      groups.forEach(function(g){
        var an=g.dataset.cat===String(ci);
        if(an&&g.hidden===false)return;
        g.hidden=!an;
        if(an&&!reduce){g.classList.remove('is-in');void g.offsetWidth;g.classList.add('is-in');}
      });
      var g=groups[ci]; if(g)hydrate(g);
      var bn=document.getElementById('dkhCpBanner');
      if(bn&&g&&g.dataset.banner&&bn.getAttribute('src')!==g.dataset.banner){bn.src=g.dataset.banner;}
      links.forEach(function(l){l.setAttribute('aria-expanded',l.dataset.cat===String(ci)?'true':'false');});
      if(!isOpen){isOpen=true;panel.classList.add('on');panel.setAttribute('aria-hidden','false');}
      else{ /* Gruppe wechselt bei offenem Panel ohne Neuauftritt der Buehne */ }
    }
    function close(){
      clearTimeout(openT);clearTimeout(closeT);
      if(!isOpen)return;isOpen=false;
      panel.classList.remove('on');panel.setAttribute('aria-hidden','true');
      links.forEach(function(l){l.setAttribute('aria-expanded','false');});
    }
    links.forEach(function(l){
      l.addEventListener('pointerenter',function(){
        if(matchMedia('(hover:none)').matches)return;
        clearTimeout(openT);
        openT=setTimeout(function(){show(l.dataset.cat);},isOpen?40:130);
      });
      l.addEventListener('focus',function(){show(l.dataset.cat);});
    });
    var zone=[document.querySelector('.dkh-cats'),panel];
    zone.forEach(function(el){
      el.addEventListener('pointerleave',function(){
        clearTimeout(closeT);
        closeT=setTimeout(function(){
          var hoverIrgendwo=zone.some(function(z){return z.matches(':hover');});
          if(!hoverIrgendwo)close();
        },160);
      });
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
    addEventListener('scroll',function(){if(isOpen&&window.scrollY>10)close();},{passive:true});
    document.addEventListener('focusout',function(e){
      setTimeout(function(){
        if(isOpen&&!panel.contains(document.activeElement)&&!document.querySelector('.dkh-cats').contains(document.activeElement))close();
      },0);
    });
  })();

  /* Panel-Licht + Signatur-Tilt: die Buehne reagiert auf die Hand des Besuchers (nur Fine-Pointer) */
  (function(){
    var panel=document.getElementById('dkhCatPanel'); if(!panel) return;
    if(reduce||!matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    panel.addEventListener('pointermove',function(e){
      var r=panel.getBoundingClientRect();
      panel.style.setProperty('--lx',((e.clientX-r.left)/r.width*100).toFixed(1)+'%');
      panel.style.setProperty('--ly',((e.clientY-r.top)/r.height*100).toFixed(1)+'%');
      var fig=e.target.closest&&e.target.closest('.dkh-cpstar');
      if(fig){
        var f=fig.querySelector('.cps-fig'); if(!f)return;
        var fr=f.getBoundingClientRect();
        var dx=(e.clientX-fr.left)/fr.width-.5, dy=(e.clientY-fr.top)/fr.height-.5;
        f.style.setProperty('--ty',(dx*5).toFixed(2)+'deg');
        f.style.setProperty('--tx',(-dy*4).toFixed(2)+'deg');
      }
    });
    panel.addEventListener('pointerout',function(e){
      var star=e.target.closest&&e.target.closest('.dkh-cpstar');
      if(star){var f=star.querySelector('.cps-fig');if(f){f.style.setProperty('--tx','0deg');f.style.setProperty('--ty','0deg');}}
    });
  })();

  /* Kauf direkt aus der Suche — Theme-eigenes Quick-Buy-Modal (Prestige), Variantenwahl inklusive */
  function openQuickBuy(url){
    const parts=url.split('?');
    let handle=(parts[0].split('/products/')[1]||'').replace(/\/+$/,'');
    if(parts[1]){const v=new URLSearchParams(parts[1]).get('variant');if(v)handle+='?variant='+v;}
    if(!handle||!window.customElements||!customElements.get('quick-buy-modal')){location.href=url;return;}
    let m=document.getElementById('dkSpQuickBuy');
    if(!m){m=document.createElement('quick-buy-modal');m.id='dkSpQuickBuy';
      m.className='quick-buy-modal modal modal--lg color-scheme color-scheme--dialog';
      document.body.append(m);}
    m.setAttribute('handle',handle);
    m.show();
  }

  window.dkQuickBuy=openQuickBuy;

  /* Warenkorb-Zähler: 0 bleibt still, ab 1 sichtbar — <cart-count> hält ihn live aktuell */
  const cartN=document.querySelector('.dkh-cart-n');
  if(cartN){
    const cc=cartN.querySelector('cart-count');
    const sync=()=>{const n=parseInt((cc&&cc.textContent||'').trim(),10);
      if(!isNaN(n)&&n>0)cartN.removeAttribute('data-zero');else cartN.setAttribute('data-zero','');};
    sync();
    if(cc&&window.MutationObserver)new MutationObserver(sync).observe(cc,{childList:true,characterData:true,subtree:true});
  }

  /* Magnetisches Siegel */
  if(!reduce&&fine){
    const seal=btn.querySelector('.dkh-seal');
    if(window.gsap){
      const qx=gsap.quickTo(seal,'x',{duration:.4,ease:'power3'}),
            qy=gsap.quickTo(seal,'y',{duration:.4,ease:'power3'});
      btn.addEventListener('pointermove',e=>{
        const r=btn.getBoundingClientRect();
        qx(((e.clientX-r.left-r.width/2)/r.width)*9);
        qy(((e.clientY-r.top-r.height/2)/r.height)*6);
      });
      btn.addEventListener('pointerleave',()=>gsap.to(seal,{x:0,y:0,duration:.55,ease:'back.out(2)'}));
      btn.addEventListener('pointerdown',()=>gsap.to(seal,{scale:.93,duration:.1,ease:'power2.out'}));
      btn.addEventListener('pointerup',()=>gsap.to(seal,{scale:1,duration:.5,ease:'back.out(2.5)'}));
    }else{
      btn.addEventListener('pointermove',e=>{
        const r=btn.getBoundingClientRect();
        const x=(e.clientX-r.left-r.width/2)/r.width,y=(e.clientY-r.top-r.height/2)/r.height;
        seal.style.transform=`translate(${(x*9).toFixed(1)}px,${(y*6).toFixed(1)}px)`;
      });
      btn.addEventListener('pointerleave',()=>{seal.style.transform='';});
    }
  }

  /* Ton + Kondensation je Sektion (Abel-Fragrance-Idiom) */
  /* DK-KINO-ROLLE: jede Abteilung mit echtem Banner oben bekommt den schwebenden
     Header. Hoehe > 100 als Sicherheitsnetz: eine leere .collection-banner-Sektion
     (Kollektion ohne Bild) zaehlt nicht — dort bleibt der Header solid, sonst
     staende heller Text auf hellem Raster. */
  var xqh=Array.prototype.find.call(
    document.querySelectorAll('.xq-hero,.dk-cat-hero,.dk-bsp-hero,.cn-main-banner,.collection-banner'),
    function(el){return el.getBoundingClientRect().height>100;});
  if(head&&xqh&&!document.getElementById('hero')){
    var xtick=false;
    function xscan(){xtick=false;var r=xqh.getBoundingClientRect();var on=r.bottom>60;
      head.classList.toggle('is-solid',!on);head.dataset.tone=on?'dark':'light';
      document.body.classList.toggle('dk-over-hero',on);}
    addEventListener('scroll',function(){if(!xtick){xtick=true;requestAnimationFrame(xscan);}},{passive:true});
    xscan();
  }
  /* DK-TONE-MESSUNG-2026-09-23: Fallback fuer Kino-Seiten, die weder #hero noch eine
     der fuenf Banner-Klassen haben -- dort lief bisher gar kein Setzer, der
     Header blieb ewig transparent mit heller Schrift und war auf jedem hellen
     Abschnitt unlesbar. Statt einer Tabelle aus Sektions-IDs wird der
     Untergrund gemessen: drei Punkte auf Hoehe der Kopfzeilen-Unterkante, das
     erste Element mit deckendem Hintergrund entscheidet. Ein einziger heller
     Punkt genuegt fuer den Balken -- lieber einmal zu viel als Text, den
     niemand lesen kann. */
  if(head&&!xqh&&!document.getElementById('hero')){
    var mtick=false,mstand='',mlast=-999;
    /* DK-TONE-BILD-2026-09-24: drei Zustaende statt zwei. Durchsichtig nur ueber einem
       Foto -- ueber flachem Dunkelgrund lief sonst Fliesstext unter der Kopfzeile
       durch. Der elementsFromPoint-Stapel enthaelt die Vorfahren schon, die
       Schleife ueber ihn ersetzt den Gang ueber parentElement. */
    function mgrund(x,y){
      var s=document.elementsFromPoint(x,y);
      for(var i=0;i<s.length;i++){var n=s[i];
        if(n===head||head.contains(n))continue;
        if(/^(IMG|VIDEO|CANVAS)$/.test(n.tagName))return 'bild';
        var m=(getComputedStyle(n).backgroundColor||'').match(/[\d.]+/g);
        if(m&&m.length>2&&(m.length<4||parseFloat(m[3])>0.5))
          return (0.2126*m[0]+0.7152*m[1]+0.0722*m[2])>128?'hell':'dunkel';
      }
      return 'dunkel';
    }
    function mscan(erzwingen){mtick=false;
      var y0=window.scrollY;
      if(!erzwingen&&mstand&&Math.abs(y0-mlast)<40)return;
      mlast=y0;
      var y=Math.round(head.getBoundingClientRect().bottom)+4;
      var g=[0.2,0.5,0.8].map(function(f){return mgrund(Math.round(innerWidth*f),y);});
      /* DK-TONE-BILD-OBEN-2026-09-24: Kino nur im ersten Bildschirm. Weiter unten
         sprang der Balken sonst bei jedem Foto zwischen durchsichtig und deckend. */
      var stand=g.indexOf('hell')>-1?'hell':(g.indexOf('dunkel')>-1?'dunkel':'bild');
      /* DK-TONE-BILD-HALTEN-2026-09-24: ueber Fotos unterhalb des ersten Bildschirms
         bleibt der Balken, wie er war -- sonst springt er bei jedem Bild um. */
      if(stand==='bild'&&y0>innerHeight*.8){if(mstand)return;stand='hell';}
      if(stand===mstand)return;mstand=stand;
      /* Ein heller Punkt genuegt fuer den Papierbalken, ein flach dunkler fuer den
         dunklen Balken; nur wenn alle drei auf einem Foto liegen, schwebt der
         Header (Kino). Keine Annahme darueber, welche Sektion ein Hero ist. */
      document.body.classList.toggle('dk-over-hero',stand==='bild');
      head.classList.toggle('is-solid',stand!=='bild');
      head.dataset.tone=stand==='hell'?'light':'dark';
    }
    addEventListener('scroll',function(){if(!mtick){mtick=true;requestAnimationFrame(function(){mscan(false);});}},{passive:true});
    addEventListener('resize',function(){mscan(true);},{passive:true});
    mscan(true);
  }
  if(document.getElementById('hero')){
  const TONE={hero:'dark',raritaeten:'light',signature:'dark',reise:'dark',dkkarte:'light',journal:'light',rohstoffe:'dark',herkunft:'dark',close:'light',tuer:'dark',katalog:'light'};
  function apply(id){
    head.dataset.tone=TONE[id]||'light';
    head.classList.toggle('is-solid',id!=='hero');
  }
  if(window.scrollY<40)apply('hero');
  if(head&&window.ScrollTrigger&&window.gsap){
    const px=Math.round(head.offsetHeight*.6)||34;
    Object.keys(TONE).forEach(id=>{
      const s=document.getElementById(id);if(!s)return;
      ScrollTrigger.create({trigger:s,start:'top '+px+'px',end:'bottom '+px+'px',
        onToggle:self=>{if(self.isActive)apply(id);}});
    });
  }else if(head){
    const ids=Object.keys(TONE).map(id=>document.getElementById(id)).filter(Boolean);
    const px=Math.round(head.offsetHeight*.6)||34;
    let tick=false;
    function scan(){tick=false;
      for(const s of ids){const r=s.getBoundingClientRect();
        if(r.top<=px&&r.bottom>px){apply(s.id);return;}}
      head.classList.remove('is-solid');head.dataset.tone='dark';
    }
    addEventListener('scroll',()=>{if(!tick){tick=true;requestAnimationFrame(scan);}},{passive:true});
    scan();
  }
  }
})();

/* DAS KABINETT — Kino-Leinwand: Hover einer Kollektion blendet ihr Banner ein (Cross-Dissolve) */
(function(){
  var dlg=document.getElementById('dkMenu'); if(!dlg) return;
  var index=document.getElementById('dkCabIndex'); if(!index) return;
  var btn=document.getElementById('dkMenuBtn');
  var items=[].slice.call(index.querySelectorAll('.dkcab-item'));
  var shots=[].slice.call(dlg.querySelectorAll('.dkcab-shot'));
  var titleEl=document.getElementById('dkCabTitle'),
      noteEl=document.getElementById('dkCabNote'),
      fromEl=document.getElementById('dkCabFrom');
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine=matchMedia('(pointer:fine)').matches;
  var hydrated=false;
  function hydrate(){ if(hydrated) return; hydrated=true;
    shots.forEach(function(s){ if(s.dataset.src&&!s.getAttribute('src')) s.src=s.dataset.src; }); }
  function activate(i){
    items.forEach(function(a){ a.classList.toggle('is-active', (+a.dataset.cab)===i); });
    shots.forEach(function(s){ s.classList.toggle('is-on', (+s.dataset.cab)===i); });
    var a=items[i]; if(!a) return;
    if(titleEl) titleEl.textContent=a.dataset.title||'';
    if(noteEl)  noteEl.textContent =a.dataset.note||'';
    if(fromEl)  fromEl.textContent =a.dataset.from||'';
  }
  var hovT=null;
  if(fine&&!reduce){
    items.forEach(function(a){
      a.addEventListener('pointerenter',function(){ clearTimeout(hovT); var i=+a.dataset.cab;
        hovT=setTimeout(function(){ activate(i); },70); });
      a.addEventListener('focus',function(){ activate(+a.dataset.cab); });
    });
  }
  if(btn){
    btn.addEventListener('pointerenter',hydrate,{once:true});
    btn.addEventListener('click',function(){ hydrate(); activate(0); });
  }
})();

/* MENÜ-Suche — Auto-Finder (native Shopify Predictive Search, Vorschläge live beim Tippen) */
(function(){
  var form=document.querySelector('.dk-menu .dkm-search'); if(!form) return;
  var input=form.querySelector('input[type="search"]');
  var box=document.getElementById('dkmSuggest');
  if(!input||!box) return;
  var t=null, cur='';
  function esc(s){return (s||'').replace(/[<>&"]/g,function(c){return c==='<'?'&lt;':c==='>'?'&gt;':c==='&'?'&amp;':'&quot;';});}
  function fmtPrice(p){var n=parseFloat(p); if(!n||n<=0) return ''; return String(p).replace('.00','').replace('.',',')+' €';}
  function render(prods,colls,q){
    var h='';
    if(colls.length){h+='<p class="dkm-sg-k">Kollektionen</p><div class="dkm-sg-chips">';
      colls.forEach(function(c){h+='<a href="'+esc(c.url)+'">'+esc(c.title)+'</a>';}); h+='</div>';}
    if(prods.length){h+='<p class="dkm-sg-k">Düfte</p>';
      prods.forEach(function(p){
        var img=p.image?('<img src="'+esc(p.image)+(p.image.indexOf('?')>-1?'&':'?')+'width=120" alt="" loading="lazy">'):'';
        var pr=fmtPrice(p.price); pr=pr?('<span class="pr">ab '+pr+'</span>'):'';
        h+='<a class="dkm-sg-p" href="'+esc(p.url)+'">'+img+'<b>'+esc(p.title)+'</b>'+pr+'</a>';
      });
      h+='<a class="dkm-sg-all" href="/search?q='+encodeURIComponent(q)+'">Alle Treffer ansehen →</a>';
    }
    if(!prods.length&&!colls.length){
      h='<p class="dkm-sg-k">Keine Vorschläge</p><a class="dkm-sg-all" href="/search?q='+encodeURIComponent(q)+'">Alles durchsuchen →</a>';}
    box.innerHTML=h; box.hidden=false;
  }
  function run(){
    var q=input.value.trim(); cur=q;
    if(q.length<2){box.hidden=true; box.innerHTML=''; return;}
    fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection&resources[limit]=6')
      .then(function(r){return r.json();})
      .then(function(d){ if(cur!==q) return; var rr=(d.resources&&d.resources.results)||{}; render(rr.products||[],rr.collections||[],q); })
      .catch(function(){});
  }
  input.addEventListener('input',function(){ clearTimeout(t); t=setTimeout(run,140); });
  input.addEventListener('focus',function(){ if(input.value.trim().length>=2) run(); });
  document.addEventListener('click',function(e){ if(!form.contains(e.target)){ box.hidden=true; } });
})();
